export default {
	locale: "en-US", // probaly array of all possible locales, first one would be default

	// Logo file name in ../assets/img/
	// If null show placeholder
	logo: "asia-insurance-logo-white.png",

	// Some design changes per tenant
	theme: {
		logoBackgroundColor: null //any valid css value for colors
	},

	// Insurance types
	// Enums we can use here are defined in localization.insurance_types
	// TODO: enable camelCase products after Kobe fixes conversion from ENUM to String
	typesOfInsurance: ["medical"],

	// TODO: this should be removed
	// We should get password rules from API because
	// when user is not logged in he can't see settings
	passwordRules: {
		requireLength: 8,
		requireDigit: true,
		requireLowercase: true,
		requireNonAlphanumeric: true,
		requireUppercase: true,
		requireUniqueChars: 1
	},

	// we use dayjs syntax: https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md#format-formatstringwithtokens-string
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm:ss",

	// ENUM of preferred currency
	// ENUMs of currencies are defined in localization
	preferredCurrency: "HKD",

	// Flags for development in case we need some flags to show/hide some features for development
	devFlags: {
		hasCommissions: true,
		hasFakeSettings: false,
		hasAdvancedUserManagement: false,
		hasPolicyActions: true,
		hasQuoteActions: true
	},

	// Settings for files upload
	filesUpload: {
		types: [
			"jpg",
			"jpeg",
			"png",
			"gif",
			"tiff",
			"webp",
			"pdf",
			"doc",
			"xdoc",
			"csv",
			"xls",
			"xlsx",
			"zip",
			"rar"
		],
		maxFileSize: 15 * 1024 * 1024
	},

	// What features can be seen by this client
	// Affects top menu and router global guard
	// id is used in router to prevent showing features that are not allowed
	// name and slug are used for menu in UI
	features: [
		"dashboard",
		"clients",
		"caseManagement",
		"policies",
		"claims",
		"products",
		"reports",
		"users",
		"internals",
		"organizations",
		"setup",
		"fileSystem"
	],

	// Feature Dashboard
	dashboard: {
		detail: {
			hasNumberOfClients: true,
			hasNumberOfPolicies: true,
			hasNumberOfQuotes: true,
			hasGraph: true
		}
	},

	// Feature clients
	clients: {
		creating: {
			// TODO: probably form config here
		},
		listing: {
			itemsPerPage: 30,
			// Here is a list of fields that will be mapped to GraphQL output
			columns: {
				individual: ["name", "email", "dateOfBirth", "createdAt", "actions"],
				company: [
					"name",
					"registrationNumber",
					"email",
					"natureOfBusiness",
					"createdAt",
					"actions"
				]
			}
		},
		detail: {
			submenu: {
				individual: [
					"overview",
					"policies",
					"objects",
					"logs" /*"quotes", "relationships"*/
				],
				company: [
					"overview",
					"policies",
					"objects",
					"logs" /*"quotes", "relationships", "employees"*/
				]
			}
		},
		updating: {}
	},

	paymentProvider: "jetco",
	// Feature Quotes
	quotes: {
		actions: {
			hasActions: true,
			hasRequestPayment: true,
			hasIssuePolicy: true,
			hasIssueExistingPolicy: true
		},

		offers: {
			hasSendOffer: true
		},

		detail: {
			hasReject: true,
			hasChangeHolder: false,
			hasAddOtherHolder: false,
			hasRemoveOtherHolder: false,
			hasAddInsured: false,
			hasRemoveInsured: false
		}
	},

	// Feature policies
	policies: {
		creating: {
			hasApiCreation: false,
			hasManualCreation: false
		},
		actions: {
			hasActions: true,
			hasRequestPayment: true,
			hasSendConfirmation: true
		},
		cancelling: {
			hasCancel: true,
			hasSendEmail: true
		}
	},

	// Feature Reports
	reports: {
		reporting: {
			hasDefault: true,
			hasVHIS: true
		}
	},

	env: {
		VHIS_EMAIL_FROM: "vhis@afh.hk",
		PDF_VHIS_STANDARD_BENEFIT_SCHEDULE_CN:
			"6d6092d7-2a53-4f4c-bb7c-dd3c89a9c7c9",
		PDF_VHIS_STANDARD_BENEFIT_SCHEDULE_EN:
			"ee33c5a4-4e1d-4c0b-9750-c9b09d5fe6bd",
		PDF_VHIS_STANDARD_TERMS_CONDITIONS_CN:
			"d457d2ad-c21b-4e12-b81f-7d56c7eb6d5b",
		PDF_VHIS_STANDARD_TERMS_CONDITIONS_EN:
			"93bc8c53-59ee-429e-b661-e0dc982a9511",
		PDF_VHIS_FLEXI_PLAN_SUPPLEMENT_B_CN: "94024473-a129-4fb1-8f00-89917a2f53c0",
		PDF_VHIS_FLEXI_PLAN_SUPPLEMENT_B_EN: "8aa1a065-68d6-4ed9-befd-1f722421c224",
		PDF_VHIS_FLEXI_PLAN_SUPPLEMENT_A_CN: "87acb581-a939-4d25-ba18-4af2ef6d12a0",
		PDF_VHIS_FLEXI_PLAN_SUPPLEMENT_A_EN: "cfc8795f-70d9-4f6c-96c4-7d34d4370bb1",
		PDF_VHIS_FLEXI_PRIVATE_BENEFIT_SCHEDULE_CN:
			"25824312-ee8d-4783-94ca-31a074313371",
		PDF_VHIS_FLEXI_PRIVATE_BENEFIT_SCHEDULE_EN:
			"8d861328-1ce6-491d-b1cc-3993a595282a",
		PDF_VHIS_FLEXI_SEMIPRIVATE_BENEFIT_SCHEDULE_CN:
			"f7afc946-c9d5-4f73-86f6-3c35b969efea",
		PDF_VHIS_FLEXI_SEMIPRIVATE_BENEFIT_SCHEDULE_EN:
			"9898b2df-35f3-49eb-b2a6-0a01a630b70a",
		PDF_VHIS_FLEXI_PLAN_TERMS_BENEFITS_CN:
			"30428a17-f121-4a54-90cc-72f152d3d9a2",
		PDF_VHIS_FLEXI_PLAN_TERMS_BENEFITS_EN:
			"233b875b-b3c2-4c2a-9e88-03ba2ff2fe78",
		EMAIL_VHIS_FLEXI_PRIVATE_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"add51845-9d34-4ee9-b378-e1eee59e3bd1",
		EMAIL_VHIS_FLEXI_PRIVATE_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"897145e4-6d92-4f49-ba42-d34cbb55ea1d",
		EMAIL_VHIS_FLEXI_PRIVATE_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"22e098de-4803-4e55-baf6-84eb29413406",
		EMAIL_VHIS_FLEXI_PRIVATE_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"bcdf2546-8636-455a-88ac-05c82952f705",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"15b4d180-faa3-42ab-8aca-e991a1d6db2a",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"120c62aa-29bb-4fd3-bbcb-7b9ccc743e75",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"e36cba8b-7b61-464b-9d69-9d62d6d8e4e5",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"dca0bb53-ae85-4fd9-a2ab-d1548147cdf6",
		EMAIL_ICARE_PLAN_1_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"ba7324a9-6a16-4d27-8f65-4dd6500a78a4",
		EMAIL_ICARE_PLAN_1_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"a0cc9a85-89b6-45fb-86f0-94333170e450",
		EMAIL_ICARE_PLAN_1_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"f7fb1836-4da4-4797-842a-185283db1288",
		EMAIL_ICARE_PLAN_1_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"6902cebe-865b-4298-bf3e-2b80791f5c30",
		EMAIL_ICARE_PLAN_1A_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"2d61e908-253f-41fb-96f7-ef6b9922fc25",
		EMAIL_ICARE_PLAN_1A_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"60de8ece-8b57-4020-922b-d569027efc03",
		EMAIL_ICARE_PLAN_1A_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"d3be236f-fb6a-4c1c-b89f-827d9c699b12",
		EMAIL_ICARE_PLAN_1A_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"0f50d84d-d177-4056-87cd-93a66dc62fcd",
		EMAIL_ICARE_PLAN_2_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"d5e69c63-0647-4e07-bd61-56fdfd94e1e9",
		EMAIL_ICARE_PLAN_2_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"5284354f-4bc7-45e4-9466-8a4956e7ff08",
		EMAIL_ICARE_PLAN_2_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"3ab1cdfa-55d9-4108-9640-060db86ebebb",
		EMAIL_ICARE_PLAN_2_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"7a0fa9d4-086a-44d2-808e-57664b3f4947",
		EMAIL_ICARE_PLAN_2A_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"48a83f82-f2e2-4ddd-b743-04df4b67d264",
		EMAIL_ICARE_PLAN_2A_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"2f12782f-2c86-402c-8fdf-4774652de004",
		EMAIL_ICARE_PLAN_2A_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"2090f836-ceee-4fc8-863a-b61231365895",
		EMAIL_ICARE_PLAN_2A_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"610be027-6737-4732-9b9a-11485fe16420",
		EMAIL_ICARE_PLAN_2B_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY_HASENDORSEMENT:
			"198bfcd9-49e5-4f6c-adaa-b166453d776d",
		EMAIL_ICARE_PLAN_2B_POLICY_ISSUANCE_ANNUAL_PAYMENT_POLICY:
			"42e73d06-bd48-43f4-8d86-74ea2ca5a71f",
		EMAIL_ICARE_PLAN_2B_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY_HASENDORSEMENT:
			"d547e4df-12f0-4807-b8ff-c40f394584fc",
		EMAIL_ICARE_PLAN_2B_POLICY_ISSUANCE_MONTHLY_PAYMENT_POLICY:
			"f3d08584-3b2b-4981-9eda-77134cdad1eb",
		EMAIL_ICARE_PLAN_1_PAYMENT_CASE: "f67230df-a044-4014-9a9a-34d909be3b3a",
		EMAIL_ICARE_PLAN_1A_PAYMENT_CASE: "a2167691-586f-475c-816f-be71a24c5317",
		EMAIL_ICARE_PLAN_2_PAYMENT_CASE: "76bf930a-f563-4090-b614-b4ec8f33c34f",
		EMAIL_ICARE_PLAN_2A_PAYMENT_CASE: "36ed0394-3775-4183-b000-1cd55fa0472d",
		EMAIL_ICARE_PLAN_2B_PAYMENT_CASE: "ee56285e-47be-4212-9b9d-08789b7b327c",
		DOC_VHIS_FLEXI_PRIVATE_COUNTEROFFER_ENDORSEMENT_POLICY:
			"9ff0d0c8-b2bb-4d89-81ed-48ffb0fb7e89",
		DOC_VHIS_FLEXI_SEMIPRIVATE_COUNTEROFFER_ENDORSEMENT_POLICY:
			"1c49d030-a90d-4a76-a203-c36b98a29689",
		DOC_VHIS_STANDARD_COUNTEROFFER_ENDORSEMENT_POLICY:
			"447b4bc5-5501-498d-8caa-495dd1b33b11",
		EMAIL_VHIS_FLEXI_PRIVATE_COUNTEROFFER_CASE_HASENDORSEMENT:
			"0eaa4113-94f3-45a2-92eb-caafbf99eef4",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_COUNTEROFFER_CASE_HASENDORSEMENT:
			"60b54246-f122-4908-a65a-10022d3b2918",
		EMAIL_VHIS_STANDARD_COUNTEROFFER_CASE_HASENDORSEMENT:
			"5c4a2201-39db-4a42-b9cf-c1b005dda9ec",
		EMAIL_VHIS_STANDARD_POLICY_ISSUANCE_POLICY_HASENDORSEMENT:
			"eb6b4e6d-6b09-4876-83ee-bd754f888b19",
		EMAIL_VHIS_FLEXI_PRIVATE_DECLINE_CASE:
			"aab9866e-164e-4f7f-9e85-a3abdcba3a24",
		EMAIL_VHIS_FLEXI_PRIVATE_CANCELLATION_POLICY:
			"ee12770e-c12f-496f-a115-4dbf888b0fd8",
		EMAIL_VHIS_FLEXI_PRIVATE_PAYMENT_CASE:
			"847c33c4-da80-4924-b1df-f50f9491dd1d",
		EMAIL_VHIS_FLEXI_PRIVATE_COUNTEROFFER_CASE:
			"cb134d8f-07d0-428c-8d32-eab7f89012fa",
		EMAIL_ICARE_PLAN_1_COUNTEROFFER_CASE_HASENDORSEMENT:
			"6c0c239b-ee6e-41d5-9a4d-f79b1d120445",
		EMAIL_ICARE_PLAN_1_COUNTEROFFER_CASE:
			"de7bfd85-68ae-41a3-b0d0-cd23fcdb5f42",
		EMAIL_ICARE_PLAN_1A_COUNTEROFFER_CASE_HASENDORSEMENT:
			"272a3dad-6bd4-4719-966c-10beb6a1d7e7",
		EMAIL_ICARE_PLAN_1A_COUNTEROFFER_CASE:
			"66213033-c403-4c6c-9f97-900271bd3bb5",
		EMAIL_ICARE_PLAN_2_COUNTEROFFER_CASE_HASENDORSEMENT:
			"7857c20d-a335-40db-a9c6-900d665eac87",
		EMAIL_ICARE_PLAN_2_COUNTEROFFER_CASE:
			"b9dc733a-80db-4f4a-9c12-1984805cb22a",
		EMAIL_ICARE_PLAN_2A_COUNTEROFFER_CASE_HASENDORSEMENT:
			"2139cac8-afe4-438c-ac92-70160563c6a6",
		EMAIL_ICARE_PLAN_2A_COUNTEROFFER_CASE:
			"20d5c80f-d8f1-45be-b744-55349f4b14df",
		EMAIL_ICARE_PLAN_2B_COUNTEROFFER_CASE_HASENDORSEMENT:
			"2ebb3571-661b-4959-94cb-436a1f7e2cd3",
		EMAIL_ICARE_PLAN_2B_COUNTEROFFER_CASE:
			"89dda98c-89e3-482f-89aa-6170bf5fe3ff",
		DOC_VHIS_FLEXI_PRIVATE_COUNTEROFFER_ENDORSEMENT_CASE:
			"560757c9-2469-40e1-b355-09e426374700",
		DOC_VHIS_FLEXI_PRIVATE_DEBIT_NOTE_CASE:
			"39b89976-0433-4ed7-ae24-02be46daf7c3",
		DOC_VHIS_FLEXI_PRIVATE_DEBIT_NOTE_POLICY:
			"479501c1-d7b0-4bce-81ce-c295d7701b68",
		DOC_VHIS_FLEXI_PRIVATE_POLICY_SCHEDULE_CASE:
			"bf082f89-1239-4405-9e7f-f2b44953cef6",
		DOC_VHIS_FLEXI_PRIVATE_POLICY_SCHEDULE_POLICY:
			"c65cdef2-75ae-4d7d-a554-4b4a2ed4ba37",
		DOC_VHIS_FLEXI_PRIVATE_COVER_PAGE_CASE:
			"1d22899b-694f-4020-8764-39eff8b4eefd",
		DOC_VHIS_FLEXI_PRIVATE_COVER_PAGE_POLICY:
			"f0077fee-bb4a-44c6-b1e8-a12d2d31f72e",
		DOC_VHIS_FLEXI_PRIVATE_APPLICATION_FORM_CASE:
			"91aac10d-4bad-4ceb-a9cb-8f2a38fd347f",
		DOC_VHIS_FLEXI_PRIVATE_APPLICATION_FORM_POLICY:
			"61fb4e47-46fe-4c09-8a6d-07c66edb8a57",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_DECLINE_CASE:
			"cbf94ab1-be3a-4eee-b66a-804263f5ce4a",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_CANCELLATION_POLICY:
			"5727970a-955d-42f2-86ea-54203100ce65",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_PAYMENT_CASE:
			"396468b9-dca5-4aba-b2cc-aeeacbbff52d",
		EMAIL_VHIS_FLEXI_SEMIPRIVATE_COUNTEROFFER_CASE:
			"8ffd0ff3-1bdc-4bf0-9bf7-a1686df57412",
		DOC_VHIS_FLEXI_SEMIPRIVATE_COUNTEROFFER_ENDORSEMENT_CASE:
			"1c228496-9506-41ea-8d4b-c69f67add93f",
		DOC_VHIS_FLEXI_SEMIPRIVATE_DEBIT_NOTE_CASE:
			"aefce143-a71b-45f5-acd9-1feda21b5c1f",
		DOC_VHIS_FLEXI_SEMIPRIVATE_DEBIT_NOTE_POLICY:
			"24ded647-6957-45ac-a57b-473d2fdf6615",
		DOC_VHIS_FLEXI_SEMIPRIVATE_POLICY_SCHEDULE_CASE:
			"32cfa409-2f17-4b99-a133-8a38694a1eba",
		DOC_VHIS_FLEXI_SEMIPRIVATE_POLICY_SCHEDULE_POLICY:
			"134ea774-655a-4163-b5a8-320bca7d61b5",
		DOC_VHIS_FLEXI_SEMIPRIVATE_COVER_PAGE_CASE:
			"46077abc-e38f-4ca2-af9c-42b11a933a3f",
		DOC_VHIS_FLEXI_SEMIPRIVATE_COVER_PAGE_POLICY:
			"fa7ea5d4-a45c-4d07-994a-ae66de9c27ba",
		DOC_VHIS_FLEXI_SEMIPRIVATE_APPLICATION_FORM_CASE:
			"ad7f83e4-b342-4dc8-a950-b06c144e1c92",
		DOC_VHIS_FLEXI_SEMIPRIVATE_APPLICATION_FORM_POLICY:
			"54d616d5-3b97-4427-a241-ac533f9ad91e",
		DOC_VHIS_STANDARD_APPLICATION_FORM_CASE:
			"0a9ed604-3675-4093-881a-079d1c7d8e34",
		DOC_VHIS_STANDARD_COVER_PAGE_CASE: "52912e26-0c7b-46ca-9307-ac168b9eeda6",
		DOC_VHIS_STANDARD_POLICY_SCHEDULE_CASE:
			"cbb20647-4e1d-44e0-8e34-dec260f20945",
		DOC_VHIS_STANDARD_DEBIT_NOTE_CASE: "d1212b4f-1a92-4072-b0fc-4200a4bc5efc",
		EMAIL_VHIS_STANDARD_COUNTEROFFER_CASE:
			"e9e0e66d-88a0-4caa-bedf-404911adf2c8",
		EMAIL_VHIS_STANDARD_PAYMENT_CASE: "2810f693-5f36-4c38-b1a8-49a55b74ac35",
		EMAIL_VHIS_STANDARD_CANCELLATION_POLICY:
			"cecbb7cf-4d02-4e00-b3bc-67df4fa757b6",
		EMAIL_VHIS_STANDARD_DECLINE_CASE: "d1349c00-7b0c-4664-9677-a41442d6f174",
		EMAIL_VHIS_STANDARD_POLICY_ISSUANCE_POLICY:
			"ba21cf6f-c99d-4cf8-9a16-13a48a4a26fd",
		DOC_VHIS_STANDARD_APPLICATION_FORM_POLICY:
			"a03e4bc3-9014-4a4d-897d-29ff15836704",
		DOC_VHIS_STANDARD_COUNTEROFFER_ENDORSEMENT_CASE:
			"f19128f7-fd63-4561-ab62-17d27240eb4b",
		DOC_VHIS_STANDARD_COVER_PAGE_POLICY: "5c71cc99-236c-4bea-bc48-c7590d810f49",
		DOC_VHIS_STANDARD_POLICY_SCHEDULE_POLICY:
			"b89c1fe3-94ac-4bdf-9e79-d16570152dc8",
		DOC_VHIS_STANDARD_DEBIT_NOTE_POLICY: "20dd151f-11f8-4091-a86e-c02da789f3f5",
		rejectSettingsTemplateId: "e9677da8-c087-469f-b6f6-548b3fe33bdc"
	}
}
